import styled from 'styled-components';

import FormInput from '../FormInput/FormInput';

export const Input = styled(FormInput)`
  padding-right: 50px;
`;

export const IconContainer = styled.div`
  height: 32px;
  position: absolute;
  right: 0;
  top: 7px;
  width: 48px;
  padding: 4px 0;
  border-left: 1px solid var(--border);
  border-right: 1px solid transparent;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
`;
